module.exports = __webpack_public_path__ + "static/img/rank_144.fbb228b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_144.png
// module id = gvIW
// module chunks = 0